"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchUserBadge = void 0;
const react_1 = __importDefault(require("react"));
const Icon_1 = require("../../../../Icon");
const UserTypeIcon_1 = require("../../../../UserTypeIcon");
require("./index.scss");
const className = 'search-user-badge';
const SearchUserBadge = (props) => {
    const { userName, onCloseClick, userType, disabled } = props;
    return (react_1.default.createElement("div", { className: className },
        userType && (react_1.default.createElement(UserTypeIcon_1.UserTypeIcon, { className: 'search-user-badge__role-icon', userType: userType })),
        react_1.default.createElement("span", { className: 'search-user-badge__name' }, userName),
        react_1.default.createElement("button", { className: 'search-user-badge__close-button', type: 'button', onClick: onCloseClick, disabled: disabled },
            react_1.default.createElement(Icon_1.Icon, { name: 'x' }))));
};
exports.SearchUserBadge = SearchUserBadge;
//# sourceMappingURL=index.js.map